import React, { useState, useEffect } from "react";
import HumanResourcesTable from "./components/HumanResourcesTable";
import Edit from "./modals/Edit";
import View from "./modals/View";
import Delete from "./modals/Remove";
import Create from "./modals/Create";
import Filter from "./modals/Filter";
import Divider from "@material-ui/core/Divider";
import Switch from "@material-ui/core/Switch";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import axios from "axios";
import { v4 as uuid } from "uuid";
import { updateObject } from "../../../helpers/updateObject";
import ChangePassword from "./modals/ChangePassword";

export default function HumanResources() {
  const [showEdit, setShowEdit] = useState(false);
  const [showView, setShowView] = React.useState(false);
  const [showRemove, setShowRemove] = useState(false);
  const [showCreate, setShowCreate] = useState(false);
  const [showFilter, setShowFilter] = React.useState(false);
  const [showChangePassword, setShowChangePassword] = useState(false);

  function handleChange() {
    setShowFilter((key) => !key);
  }

  const toggleDrawer = (open) => (event) => {
    if (
      event.type === "keydown" &&
      (event.key === "Tab" || event.key === "Shift")
    ) {
      return;
    }

    setShowView(open);
  };

  const [error, setError] = useState(false);
  const [isLoaded, setIsLoaded] = useState(false);
  const [sortField, setSortField] = useState("id");
  const [orderBy, setOrderBy] = useState(false);
  const [rows, setRows] = useState([]);
  const [humanResource, setHumanResource] = useState({});
  const [skip, setSkip] = useState(0);
  const [take, setTake] = useState(10);
  const [count, setCount] = useState(0);
  const [humanResourceId, setHumanResourceId] = useState(null);
  const [deleteHumanResourcesIds, setDeleteHumanResourcesIds] = useState([]);
  const [filter, setFilter] = useState(false);
  const [filterInputs, setFilterInputs] = useState({
    assetName: "",
    humanResourceFullName: "",
  });

  const [assets, setAssets] = useState([]);

  const onHumanResources = (skip, take, sortField, orderBy) => {
    setIsLoaded(true);
    axios
      .get(
        `${process.env.REACT_APP_API_URL}humanResource?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        }
        ).catch((error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        });
  };
  const onFilter = (skip, take, sortField, orderBy, filterInputs) => {
    setIsLoaded(true);
    const { assetName, humanResourceFullName } = filterInputs;
    axios
      .get(
        `${process.env.REACT_APP_API_URL}humanResource/filter?Skip=${skip}&Take=${take}&SortField=${sortField}&OrderBy=${orderBy}&AssetName=${assetName}&HumanResourceFullName=${humanResourceFullName}`,
        {
          headers: {
            "Accept-Language": 1,
          },
        }
      )
      .then(
        ({ data: { data, totalCount } }) => {
          setIsLoaded(false);
          setRows(data);
          setCount(totalCount);
          setError(false);
        },
        (error) => {
          setIsLoaded(false);
          setError(true);
          setRows([]);
          setCount(0);
        }
      );
  };

  const onHumanResourceChoose = (id) => {
    axios
      .get(`${process.env.REACT_APP_API_URL}humanResource/${id}`)
      .then(({ data }) => {
        setHumanResource(data);
      });
  };

  const onUpdateUserStatus = (id, statusType) => {
    let isActive = !statusType;
    axios
      .patch(
        `${process.env.REACT_APP_API_URL}humanResource/active`,
        {
          id,
          isActive,
        },
        {
          headers: {
            "x-requestid": uuid(),
          },
        }
      )
      .then(() => {
        onHumanResources(skip, take, sortField, orderBy);
      });
  };

  const onDeleteHumanResources = () => {
    axios
      .delete(`${process.env.REACT_APP_API_URL}humanResource`, {
        headers: {
          "x-requestid": uuid(),
        },
        data: {
          id: deleteHumanResourcesIds,
        },
      })
      .then((res) => {
        setDeleteHumanResourcesIds([]);
        onHumanResources(skip, take, sortField, orderBy);
      });
  };

  const filterInputsUpdate = (e) => {
    const updateFiltersInput = updateObject(filterInputs, {
      [e.target.name]: e.target.value,
    });

    setFilterInputs(updateFiltersInput);
    setSkip(0);
    setFilter(true);
  };

  const onAssets = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}asset`, {
        headers: {
          "Accept-Language": 1,
        },
      })
      .then(({ data: { data } }) => {
        setAssets(data);
      });
  };

  useEffect(() => {
    onAssets();
  }, []);

  useEffect(() => {
    if (filter) {
      const timer = setTimeout(() => {
        onFilter(skip, take, sortField, orderBy, filterInputs);
      }, 500);

      return () => clearTimeout(timer);
    } else {
      onHumanResources(skip, take, sortField, orderBy);
    }
  }, [skip, take, sortField, orderBy, filter, filterInputs]);

  useEffect(() => {
    if (!showView || !showEdit) setHumanResource({});
  }, [showView, showEdit]);

  const onHumanResourcesExport = () => {
    axios
      .get(`${process.env.REACT_APP_API_URL}humanResource/export`, {
        responseType: "blob",
      })
      .then((res) => {
        var url = window.URL.createObjectURL(new Blob([res.data]));
        var a = document.createElement("a");
        a.href = url;
        a.download = "HumanResource.xlsx";
        document.body.appendChild(a);
        a.click();
        a.remove();
      });
  };

  return (
    <div className="row bg-white rounded">
      <div className="col-12 d-flex align-items-center py-4 fixed-title">
        <h1 className="display-4 mb-0">Hr Account</h1>
        <FormControlLabel
          control={
            <Switch
              checked={showFilter}
              onChange={handleChange}
              color="secondary"
            />
          }
          label={showFilter ? "Hide filter" : "Show filter"}
          className="ml-auto mb-0"
        />
      </div>
      <Divider className="w-100" />
      <HumanResourcesTable
        setSortField={setSortField}
        setOrderByTable={setOrderBy}
        sortField={sortField}
        orderBy={orderBy}
        setOpenEdit={setShowEdit}
        setOpenView={toggleDrawer(true)}
        setOpenRemove={setShowRemove}
        setOpenCreate={setShowCreate}
        isLoaded={isLoaded}
        error={error}
        rows={rows}
        onHumanResourceChoose={onHumanResourceChoose}
        updateSkip={setSkip}
        updateTake={setTake}
        count={count}
        onUpdateUserStatus={onUpdateUserStatus}
        setHumanResourceId={setHumanResourceId}
        setDeleteHumanResourcesID={setDeleteHumanResourcesIds}
        deleteHumanResourcesIds={deleteHumanResourcesIds}
        onDeleteHumanResources={onDeleteHumanResources}
        onHumanResourcesExport={onHumanResourcesExport}
        setOpenChangePassword={setShowChangePassword}
      />
      <Edit
        humanResource={humanResource}
        show={showEdit}
        onHide={setShowEdit}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onHumanResources={onHumanResources}
        assets={assets}
      />
      <View
        humanresource={humanResource}
        open={showView}
        onClose={toggleDrawer(false)}
      />
      <Delete
        id={humanResourceId}
        show={showRemove}
        onHide={setShowRemove}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        onHumanResources={onHumanResources}
      />
      <Create
        show={showCreate}
        onHide={setShowCreate}
        onHumanResources={onHumanResources}
        skip={skip}
        take={take}
        sortField={sortField}
        orderBy={orderBy}
        assets={assets}
      />
      <ChangePassword
        show={showChangePassword}
        onHide={setShowChangePassword}
        id={humanResourceId}
      />
      <Filter
        show={showFilter}
        onHide={handleChange}
        filterInputsUpdate={filterInputsUpdate}
        filterInputs={filterInputs}
      />
    </div>
  );
}
